import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  Duration__compareTo_impl_pchp0f3d3hhywzdbk51 as Duration__compareTo_impl_pchp0f,
  Duration5ynfiptaqcrg as Duration,
  Duration__toString_impl_8d916b11f1kpclwmkpg as Duration__toString_impl_8d916b,
  Duration__minus_impl_q5cfm71nk0r3iamfcb8 as Duration__minus_impl_q5cfm7,
  Duration__hashCode_impl_u4exz629donm5f9ouki as Duration__hashCode_impl_u4exz6,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  OnField23al9ljlbymf9 as OnField,
  Equal3ow85705ftxfk as Equal,
  Inside39cktoz42t35z as Inside,
} from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import {
  use25wcggkyjf1ad as use,
  set_value1vvx5pkb20ebv as set_value,
} from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  launch1c91vkjzdi9sd as launch,
  asyncz02dsa2nb2zt as async,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  ReactiveState__getOrNull_impl_1asnfp2wx27g6rqhoxq as ReactiveState__getOrNull_impl_1asnfp,
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance_0,
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
  ReactiveStatel8ixobo86msn as ReactiveState,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReady_instance37iasaqvolrrz as InternalReactiveNotReady_instance,
} from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { withTimeoutOrNull34xgdz9p3adh5 as withTimeoutOrNull } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Timeout.mjs';
import { maxOfnpw4mt1rg0hl as maxOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/_ComparisonsJs.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope284yy3flyb2v2 as coroutineScope,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  setOf1u3mizs95ngxo as setOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  MutationResultxmj9lk13qzu5 as MutationResult,
  DeletionResultccwd2e565l92 as DeletionResult,
  MultiGetResults6dlyquirmyb as MultiGetResult,
  QueryResult2ufeva9wjs3uo as QueryResult,
  SocketOverload2oan4qiwxidew as SocketOverload,
  SocketChanges3116hd430s44s as SocketChanges,
} from './CacheUpdate.mjs';
import { awaitOnce2ui7qqi9bvdeq as awaitOnce } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { modification1bed5xcrmg3fq as modification } from '../../lightningdb/modification.diff.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  asSequence2phdjljfh9jhx as asSequence,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { minus165a8u1e0x1lu as minus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { awaitAll3u8r91uegk3sa as awaitAll } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Await.mjs';
import {
  LateInitSignal30crwrg540xyy as LateInitSignal,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  ResourceUse2vo6us5ch1uy1 as ResourceUse,
  uses26aso754i5iou as uses,
  InterruptibleDelay2c0xh0wdvl7bj as InterruptibleDelay,
} from './utils.mjs';
import {
  lens27v59dqa1oc3r as lens,
  lensListenable3n4xxl63wcyqk as lensListenable,
} from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/HasId.mjs';
import {
  lens2x0usmj7eco4 as lens_0,
  lens2po2j99uxhjgr as lens_1,
  beginUse146s8dwmfk72s as beginUse,
  Reactive1jy75v4li6ldv as Reactive,
  MutableReactive2qdhhyljdknhy as MutableReactive,
} from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import {
  LimitReadable2ecfn2s8p9gvk as LimitReadable,
  ClientModelRestEndpointsPlusUpdatesWebsocket34r6fusayskwn as ClientModelRestEndpointsPlusUpdatesWebsocket,
} from './deprecated.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { _id10wcwzezpuldz as _id } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/HasIdFields.mjs';
import { SharedCollectionUpdatesSocket32e1skqgvgdc7 as SharedCollectionUpdatesSocket } from './SharedCollectionUpdatesSocket.mjs';
import { BatchAndQueue1zjqkogt1zg44 as BatchAndQueue } from './BatchAndQueue.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { WithTimestamp1a7xpvbvrfq5g as WithTimestamp } from './WithTimestamp.mjs';
import { NaiveListReconstructionCalculator3qc7njeca2h45 as NaiveListReconstructionCalculator } from './NaiveListReconstructionCalculator.mjs';
import { BufferOverflow_DROP_OLDEST_getInstance1vyzet7fbhkje as BufferOverflow_DROP_OLDEST_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/BufferOverflow.mjs';
import { MutableSharedFlow3g4w4npzofx4w as MutableSharedFlow } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/SharedFlow.mjs';
import {
  filter184huxd00uyfg as filter,
  mapNotNull3b8ce5hky4k2l as mapNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { Companion_getInstance3vjikuur3h0k4 as Companion_getInstance_1 } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import {
  item$default3dyc55m87z853 as item$default,
  list$defaultjjoam74xw8wt as list$default,
  getejg6weymx5xn as get,
  query29ckg2onhz2o6 as query,
  watchfa0nguk2p1l7 as watch,
  watchixvkipmba2qg as watch_0,
  insert3im47febzvlie as insert,
  ModelCacheLike1q3b58tuu7jn2 as ModelCacheLike,
} from './ModelCacheLike.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp0_safe_receiver = $this.iel_1.ael_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.fcv(['Fetching after socket connected']);
  }
  try {
    var tmp = $this.jel_1.adw_1.vah($this.iel_1.xek_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Exception()) {
      var e = $p;
      println('WARN: ' + e.toString());
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$withTimeoutOrNull, $completion) {
  var tmp = $this.kel_1.rel($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = $this.lel_1.ael_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.fcv(['Socket connected.']);
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $this$ResourceUse, $completion) {
  onRemove($this$ResourceUse, () => {
    var tmp0_safe_receiver = $this.sel_1.ael_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.fcv(['No longer needed']);
    }
    return Unit_instance;
  });
  var tmp;
  var tmp_0;
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(30, DurationUnit_SECONDS_getInstance());
  if (Duration__compareTo_impl_pchp0f($this.sel_1.zek_1, tmp$ret$0) < 0) {
    tmp_0 = !($this.tel_1.zdv_1 == null);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var tmp0_safe_receiver = $this.sel_1.ael_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.fcv(['Using socket']);
    }
    var r = $this.tel_1.zdv_1.aem(OnField().h3t($this.tel_1.wdv_1, Equal().e3r($this.sel_1.xek_1)));
    use($this$ResourceUse, r);
    onRemove($this$ResourceUse, r.pel_1.tah(() => {
      var tmp;
      if (r.pel_1.f2()) {
        launch($this$ResourceUse, VOID, VOID, ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda$lambda$slambda_0($this.sel_1, $this.tel_1));
        tmp = Unit_instance;
      }
      return Unit_instance;
    }));
    tmp = r;
  } else {
    tmp = null;
  }
  var socketToWaitFor = tmp;
  var tmp1_safe_receiver = ReactiveState__getOrNull_impl_1asnfp($this.sel_1.cel_1.qah());
  var tmp_1;
  if (tmp1_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_2;
    var tmp_3;
    if ($this.tel_1.dem(tmp1_safe_receiver)) {
      tmp_3 = true;
    } else {
      // Inline function 'com.lightningkite.now' call
      var tmp$ret$1 = get_default(Companion_instance).d1m();
      tmp_3 = Duration__compareTo_impl_pchp0f(tmp$ret$1.x26(tmp1_safe_receiver.cem_1), $this.sel_1.yek_1) < 0;
    }
    if (tmp_3) {
      var tmp0_safe_receiver_0 = $this.sel_1.ael_1;
      var tmp_4;
      if (tmp0_safe_receiver_0 == null) {
        tmp_4 = null;
      } else {
        tmp0_safe_receiver_0.fcv(['Found existing value ' + tmp1_safe_receiver.cem_1.toString()]);
        tmp_4 = Unit_instance;
      }
      tmp_2 = tmp_4;
    } else {
      tmp_2 = null;
    }
    tmp_1 = tmp_2;
  }
  if (tmp_1 == null) {
    // Inline function 'kotlin.run' call
    if (!(socketToWaitFor == null)) {
      var tmp0_safe_receiver_1 = $this.sel_1.ael_1;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        tmp0_safe_receiver_1.fcv(['Waiting for socket to connect...']);
      }
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance();
      var tmp_5 = toDuration(5, DurationUnit_SECONDS_getInstance());
      var tmp_6 = withTimeoutOrNull(tmp_5, ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda$slambda_0(socketToWaitFor, $this.sel_1), $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      if (tmp_6 == null) {
        var tmp2_safe_receiver = $this.sel_1.ael_1;
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.fcv(['Failed to connect to socket']);
        }
      }
    }
    var tmp3_safe_receiver = $this.sel_1.ael_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.fcv(['Initial fetch']);
    }
    try {
      var tmp_7 = $this.tel_1.adw_1.vah($this.sel_1.xek_1, $completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
    } catch ($p) {
      if ($p instanceof Exception()) {
        var e = $p;
        println('WARN: ' + e.toString());
      } else {
        throw $p;
      }
    }
    var tmp4_safe_receiver = $this.sel_1.ael_1;
    var tmp_8;
    if (tmp4_safe_receiver == null) {
      tmp_8 = null;
    } else {
      tmp4_safe_receiver.fcv(['Initial fetch complete.']);
      tmp_8 = Unit_instance;
    }
  }
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance();
  var tmp$ret$7 = toDuration(5, DurationUnit_SECONDS_getInstance());
  var pullFrequency = maxOf(new (Duration())(tmp$ret$7), new (Duration())($this.sel_1.zek_1)).nj_1;
  while (true) {
    var tmp3_safe_receiver_0 = ReactiveState__getOrNull_impl_1asnfp($this.sel_1.cel_1.qah());
    var tmp4_elvis_lhs = tmp3_safe_receiver_0 == null ? null : $this.tel_1.eem(tmp3_safe_receiver_0, pullFrequency);
    var tmp_9;
    var tmp_10 = tmp4_elvis_lhs;
    if ((tmp_10 == null ? null : new (Duration())(tmp_10)) == null) {
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance();
      tmp_9 = toDuration(-1, DurationUnit_SECONDS_getInstance());
    } else {
      tmp_9 = tmp4_elvis_lhs;
    }
    var next = tmp_9;
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    var tmp$ret$9 = toDuration(0, DurationUnit_SECONDS_getInstance());
    if (Duration__compareTo_impl_pchp0f(next, tmp$ret$9) > 0) {
      var tmp5_safe_receiver = $this.sel_1.ael_1;
      if (tmp5_safe_receiver == null)
        null;
      else {
        tmp5_safe_receiver.fcv(['No need to pull for ' + Duration__toString_impl_8d916b(next)]);
      }
      var tmp_11 = $this.sel_1.bel_1.hem(next, $completion);
      if (tmp_11 === get_COROUTINE_SUSPENDED())
        tmp_11 = yield tmp_11;
    } else {
      var tmp6_safe_receiver = $this.sel_1.ael_1;
      if (tmp6_safe_receiver == null)
        null;
      else {
        tmp6_safe_receiver.fcv(['Needs pull, starting']);
      }
      try {
        var tmp_12 = $this.tel_1.adw_1.vah($this.sel_1.xek_1, $completion);
        if (tmp_12 === get_COROUTINE_SUSPENDED())
          tmp_12 = yield tmp_12;
      } catch ($p) {
        if ($p instanceof Exception()) {
          var e_0 = $p;
          println('WARN: ' + e_0.toString());
        } else {
          throw $p;
        }
      }
      var tmp_13 = $this.sel_1.bel_1.hem(pullFrequency, $completion);
      if (tmp_13 === get_COROUTINE_SUSPENDED())
        tmp_13 = yield tmp_13;
    }
  }
  return Unit_instance;
}
var ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda$lambda$slambdaClass;
function ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda$lambda$slambda() {
  if (ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, this$1) {
        this.iel_1 = this$0;
        this.jel_1 = this$1;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda$lambda$slambdaClass = $;
  }
  return ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda$lambda$slambdaClass;
}
function ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda$lambda$slambda_0(this$0, this$1) {
  var i = new (ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda$lambda$slambda())(this$0, this$1);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda$slambdaClass;
function ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda$slambda() {
  if (ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda$slambdaClass === VOID) {
    class $ {
      constructor($socketToWaitFor, this$0) {
        this.kel_1 = $socketToWaitFor;
        this.lel_1 = this$0;
      }
      wah($this$withTimeoutOrNull, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$withTimeoutOrNull), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda$slambdaClass = $;
  }
  return ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda$slambdaClass;
}
function ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda$slambda_0($socketToWaitFor, this$0) {
  var i = new (ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda$slambda())($socketToWaitFor, this$0);
  var l = ($this$withTimeoutOrNull, $completion) => i.wah($this$withTimeoutOrNull, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_modify__nczk7i($this, modification, $completion) {
  var tmp = $this.hel_1.rdv_1.eek($this.xek_1, modification, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.also' call
  var this_0 = tmp;
  // Inline function 'kotlin.run' call
  $this.hel_1.xdv_1.mam(new (MutationResult())(listOf(this_0)));
  return this_0;
}
function *_generator_delete__spiywt($this, $completion) {
  var tmp = $this.hel_1.rdv_1.fek($this.xek_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.run' call
  $this.hel_1.xdv_1.mam(new (DeletionResult())(setOf($this.xek_1)));
  return Unit_instance;
}
function *_generator_set__cb7isu($this, value, $completion) {
  if (value == null) {
    var tmp = $this.iem($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } else {
    var tmp_0 = awaitOnce($this, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var existing = tmp_0;
    if (existing == null) {
      var tmp_1 = $this.hel_1.rdv_1.cek(value, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      // Inline function 'kotlin.also' call
      var this_0 = tmp_1;
      // Inline function 'kotlin.run' call
      $this.hel_1.xdv_1.mam(new (MutationResult())(listOf(this_0)));
    } else {
      var tmp0_safe_receiver = modification($this.hel_1.sdv_1, existing, value);
      var tmp_2;
      if (tmp0_safe_receiver == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp_3 = $this.hel_1.rdv_1.eek($this.xek_1, tmp0_safe_receiver, $completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        tmp_2 = tmp_3;
      }
      var tmp1_safe_receiver = tmp_2;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.run' call
        $this.hel_1.xdv_1.mam(new (MutationResult())(listOf(tmp1_safe_receiver)));
      }
    }
  }
  return Unit_instance;
}
var ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambdaClass;
function ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda() {
  if (ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambdaClass === VOID) {
    class $ {
      constructor(this$0, this$1) {
        this.sel_1 = this$0;
        this.tel_1 = this$1;
      }
      wah($this$ResourceUse, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$ResourceUse), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambdaClass = $;
  }
  return ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambdaClass;
}
function ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda_0(this$0, this$1) {
  var i = new (ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda())(this$0, this$1);
  var l = ($this$ResourceUse, $completion) => i.wah($this$ResourceUse, $completion);
  l.$arity = 1;
  return l;
}
function ModelCache$ModelCacheItemReadableImpl$diff$lambda(it) {
  return it.bem_1;
}
function ModelCache$ModelCacheItemReadableImpl$lastUpdatedAt$lambda(it) {
  return it.cem_1;
}
function *_generator_invoke__zhh2q8_2($this, $this$launch, $completion) {
  var tmp0_safe_receiver = $this.jem_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.fcv(['Fetching after socket connected']);
  }
  try {
    var tmp = $this.kem_1.bdw_1.vah($this.lem_1.qem_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Exception()) {
      var e = $p;
      println('WARN: ' + e.toString());
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $this$withTimeoutOrNull, $completion) {
  var tmp0_safe_receiver = $this.yem_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.fcv(['Waiting for socket to connect...']);
  }
  var tmp = $this.zem_1.rel($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp1_safe_receiver = $this.yem_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.fcv(['Socket connected.']);
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $this$ResourceUse, $completion) {
  var tmp0_safe_receiver = $this.aen_1.vdv_1;
  var log = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zbm(toString($this.ben_1.qem_1.s49_1) + ' ' + toString($this.ben_1.qem_1.t49_1));
  var tmp;
  var tmp_0;
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(30, DurationUnit_SECONDS_getInstance());
  if (Duration__compareTo_impl_pchp0f($this.ben_1.oem_1, tmp$ret$0) < 0) {
    tmp_0 = !($this.aen_1.zdv_1 == null);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    if (log == null)
      null;
    else {
      log.fcv(['Using socket']);
    }
    var r = $this.aen_1.zdv_1.aem($this.ben_1.qem_1.s49_1);
    use($this$ResourceUse, r);
    onRemove($this$ResourceUse, r.pel_1.tah(() => {
      var tmp;
      if (r.pel_1.f2()) {
        launch($this$ResourceUse, VOID, VOID, ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda$lambda$slambda_0(log, $this.aen_1, $this.ben_1));
        tmp = Unit_instance;
      }
      return Unit_instance;
    }));
    tmp = r;
  } else {
    tmp = null;
  }
  var socketToWaitFor = tmp;
  var tmp2_safe_receiver = $this.aen_1.ddw_1.vek($this.ben_1.qem_1);
  var tmp_1;
  if (tmp2_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_2;
    var tmp_3;
    if ($this.aen_1.fen($this.ben_1.qem_1.s49_1, tmp2_safe_receiver.een_1)) {
      tmp_3 = true;
    } else {
      // Inline function 'com.lightningkite.now' call
      var tmp$ret$1 = get_default(Companion_instance).d1m();
      tmp_3 = Duration__compareTo_impl_pchp0f(tmp$ret$1.x26(tmp2_safe_receiver.een_1), $this.ben_1.nem_1) < 0;
    }
    if (tmp_3) {
      var tmp_4;
      if (log == null) {
        tmp_4 = null;
      } else {
        log.fcv(['Found existing value ' + tmp2_safe_receiver.een_1.toString() + ' / ' + tmp2_safe_receiver.den_1]);
        tmp_4 = Unit_instance;
      }
      tmp_2 = tmp_4;
    } else {
      tmp_2 = null;
    }
    tmp_1 = tmp_2;
  }
  if (tmp_1 == null) {
    // Inline function 'kotlin.run' call
    if (!(socketToWaitFor == null)) {
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance();
      var tmp_5 = toDuration(5, DurationUnit_SECONDS_getInstance());
      var tmp_6 = withTimeoutOrNull(tmp_5, ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda$slambda_0(log, socketToWaitFor), $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      if (tmp_6 == null) {
        if (log == null)
          null;
        else {
          log.fcv(['Failed to connect to socket']);
        }
      }
    }
    if (log == null)
      null;
    else {
      log.fcv(['Initial fetch']);
    }
    try {
      var tmp_7 = $this.aen_1.bdw_1.vah($this.aen_1.ddw_1.wek($this.ben_1.qem_1), $completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
    } catch ($p) {
      if ($p instanceof Exception()) {
        var e = $p;
        println('WARN: ' + e.toString());
      } else {
        throw $p;
      }
    }
    var tmp_8;
    if (log == null) {
      tmp_8 = null;
    } else {
      log.fcv(['Initial fetch complete.']);
      tmp_8 = Unit_instance;
    }
  }
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance();
  var tmp$ret$7 = toDuration(5, DurationUnit_SECONDS_getInstance());
  var pullFrequency = maxOf(new (Duration())(tmp$ret$7), new (Duration())($this.ben_1.oem_1)).nj_1;
  while (true) {
    var mostRecent = $this.aen_1.ddw_1.vek($this.ben_1.qem_1);
    var tmp_9;
    if (mostRecent == null) {
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance();
      tmp_9 = toDuration(-1, DurationUnit_SECONDS_getInstance());
    } else if (mostRecent.den_1 < $this.ben_1.qem_1.v49_1) {
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance();
      tmp_9 = toDuration(-1, DurationUnit_SECONDS_getInstance());
    } else if ($this.aen_1.fen($this.ben_1.qem_1.s49_1, mostRecent.een_1)) {
      tmp_9 = pullFrequency;
    } else {
      // Inline function 'com.lightningkite.now' call
      var tmp$ret$10 = get_default(Companion_instance).d1m();
      tmp_9 = Duration__minus_impl_q5cfm7(pullFrequency, tmp$ret$10.x26(mostRecent.een_1));
    }
    var next = tmp_9;
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    var tmp$ret$11 = toDuration(0, DurationUnit_SECONDS_getInstance());
    if (Duration__compareTo_impl_pchp0f(next, tmp$ret$11) > 0) {
      if (log == null)
        null;
      else {
        log.fcv(['No need to pull for ' + Duration__toString_impl_8d916b(next)]);
      }
      var tmp_10 = $this.ben_1.pem_1.hem(next, $completion);
      if (tmp_10 === get_COROUTINE_SUSPENDED())
        tmp_10 = yield tmp_10;
    } else {
      if (log == null)
        null;
      else {
        var tmp_11 = toString_0(mostRecent == null ? null : mostRecent.een_1);
        log.fcv(['Needs pull, starting because most recent is ' + tmp_11 + ' / ' + (mostRecent == null ? null : mostRecent.den_1)]);
      }
      try {
        var tmp_12 = $this.aen_1.bdw_1.vah($this.aen_1.ddw_1.wek($this.ben_1.qem_1), $completion);
        if (tmp_12 === get_COROUTINE_SUSPENDED())
          tmp_12 = yield tmp_12;
      } catch ($p) {
        if ($p instanceof Exception()) {
          var e_0 = $p;
          println('WARN: ' + e_0.toString());
        } else {
          throw $p;
        }
      }
      var tmp_13 = $this.ben_1.pem_1.hem(pullFrequency, $completion);
      if (tmp_13 === get_COROUTINE_SUSPENDED())
        tmp_13 = yield tmp_13;
    }
  }
  return Unit_instance;
}
var ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda$lambda$slambdaClass;
function ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda$lambda$slambda() {
  if (ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($log, this$0, this$1) {
        this.jem_1 = $log;
        this.kem_1 = this$0;
        this.lem_1 = this$1;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda$lambda$slambdaClass = $;
  }
  return ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda$lambda$slambdaClass;
}
function ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda$lambda$slambda_0($log, this$0, this$1) {
  var i = new (ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda$lambda$slambda())($log, this$0, this$1);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda$slambdaClass;
function ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda$slambda() {
  if (ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda$slambdaClass === VOID) {
    class $ {
      constructor($log, $socketToWaitFor) {
        this.yem_1 = $log;
        this.zem_1 = $socketToWaitFor;
      }
      wah($this$withTimeoutOrNull, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$withTimeoutOrNull), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda$slambdaClass = $;
  }
  return ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda$slambdaClass;
}
function ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda$slambda_0($log, $socketToWaitFor) {
  var i = new (ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda$slambda())($log, $socketToWaitFor);
  var l = ($this$withTimeoutOrNull, $completion) => i.wah($this$withTimeoutOrNull, $completion);
  l.$arity = 1;
  return l;
}
var ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambdaClass;
function ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda() {
  if (ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambdaClass === VOID) {
    class $ {
      constructor(this$0, this$1) {
        this.aen_1 = this$0;
        this.ben_1 = this$1;
      }
      wah($this$ResourceUse, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, $this$ResourceUse), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambdaClass = $;
  }
  return ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambdaClass;
}
function ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda_0(this$0, this$1) {
  var i = new (ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda())(this$0, this$1);
  var l = ($this$ResourceUse, $completion) => i.wah($this$ResourceUse, $completion);
  l.$arity = 1;
  return l;
}
function ModelCache$ModelCacheLimitReadableImpl$lastUpdatedAt$lambda(it) {
  return it == null ? null : it.een_1;
}
function *_generator_invoke__zhh2q8_5($this, it, $completion) {
  var tmp = $this.gen_1.rdv_1.aek(new (Query())(OnField().h3t($this.gen_1.wdv_1, Inside().i3r(it))), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var r = tmp;
  var tmp_0 = toSet(it);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = HashSet().ha();
  var _iterator__ex2g4s = r.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = item.h40();
    destination.v(tmp$ret$0);
  }
  $this.gen_1.xdv_1.mam(new (MultiGetResult())(minus(tmp_0, destination), r));
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(r, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s_0 = r.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element = _iterator__ex2g4s_0.o1();
    var tmp$ret$2 = element.h40();
    destination_0.s3(tmp$ret$2, element);
  }
  var map = destination_0;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList().u(collectionSizeOrDefault(it, 10));
  var _iterator__ex2g4s_1 = it.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var item_0 = _iterator__ex2g4s_1.o1();
    var tmp$ret$5 = map.p3(item_0);
    destination_1.v(tmp$ret$5);
  }
  return destination_1;
}
function *_generator_invoke__zhh2q8_6($this, $this$async, $completion) {
  var tmp = $this.hen_1.rdv_1.aek($this.ien_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var r = tmp;
  $this.hen_1.xdv_1.mam(new (QueryResult())($this.ien_1, r));
  return r;
}
var ModelCache$queryInternal$slambda$slambda$slambdaClass;
function ModelCache$queryInternal$slambda$slambda$slambda() {
  if (ModelCache$queryInternal$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $it) {
        this.hen_1 = this$0;
        this.ien_1 = $it;
      }
      wah($this$async, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, $this$async), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ModelCache$queryInternal$slambda$slambda$slambdaClass = $;
  }
  return ModelCache$queryInternal$slambda$slambda$slambdaClass;
}
function ModelCache$queryInternal$slambda$slambda$slambda_0(this$0, $it) {
  var i = new (ModelCache$queryInternal$slambda$slambda$slambda())(this$0, $it);
  var l = ($this$async, $completion) => i.wah($this$async, $completion);
  l.$arity = 1;
  return l;
}
var ModelCache$queryInternal$slambda$slambdaClass;
function ModelCache$queryInternal$slambda$slambda() {
  if (ModelCache$queryInternal$slambda$slambdaClass === VOID) {
    class $ {
      constructor($it, this$0) {
        this.jen_1 = $it;
        this.ken_1 = this$0;
      }
      wah($this$coroutineScope, $completion) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.jen_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var tmp$ret$0 = async($this$coroutineScope, VOID, VOID, ModelCache$queryInternal$slambda$slambda$slambda_0(this.ken_1, item));
          destination.v(tmp$ret$0);
        }
        return awaitAll(destination, $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ModelCache$queryInternal$slambda$slambdaClass = $;
  }
  return ModelCache$queryInternal$slambda$slambdaClass;
}
function ModelCache$queryInternal$slambda$slambda_0($it, this$0) {
  var i = new (ModelCache$queryInternal$slambda$slambda())($it, this$0);
  var l = ($this$coroutineScope, $completion) => i.wah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
var ModelCacheItemReadableImplClass;
function ModelCacheItemReadableImpl() {
  if (ModelCacheItemReadableImplClass === VOID) {
    class $ {
      constructor($outer, id, maximumAge, pullFrequency) {
        this.hel_1 = $outer;
        this.xek_1 = id;
        this.yek_1 = maximumAge;
        this.zek_1 = pullFrequency;
        var tmp = this;
        var tmp0_safe_receiver = this.hel_1.vdv_1;
        tmp.ael_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zbm(toString(this.xek_1));
        this.bel_1 = this.hel_1.ydv_1.tat();
        var tmp_0 = this;
        var tmp0 = this.hel_1.cdw_1;
        // Inline function 'kotlin.collections.getOrPut' call
        var key = this.xek_1;
        var value = tmp0.p3(key);
        var tmp_1;
        if (value == null) {
          var answer = LateInitSignal().raq();
          tmp0.s3(key, answer);
          tmp_1 = answer;
        } else {
          tmp_1 = value;
        }
        tmp_0.cel_1 = tmp_1;
        var tmp_2 = this;
        tmp_2.del_1 = ResourceUse(this.hel_1.udv_1, ModelCache$ModelCacheItemReadableImpl$processWhileRunning$slambda_0(this, this.hel_1));
        var tmp_3 = this;
        tmp_3.eel_1 = uses(lens(this.cel_1, ModelCache$ModelCacheItemReadableImpl$diff$lambda), this.del_1);
        var tmp_4 = this;
        tmp_4.fel_1 = lens(this.cel_1, ModelCache$ModelCacheItemReadableImpl$lastUpdatedAt$lambda);
        var tmp_5 = this;
        var tmp_6 = this.hel_1.udv_1.ea2();
        tmp_5.gel_1 = remember(tmp_6, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = this.hel_1.zdv_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zel_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            $this$remember.aaj(tmp1_safe_receiver);
          }
          return this.hel_1.dem($this$remember.baj(this.cel_1));
        });
      }
      var() {
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
        var this_0 = this.cel_1.qah();
        var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
        var tmp;
        if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
          tmp = new (ReactiveState())(Companion_getInstance_0().mah_1);
        } else {
          if (tmp0_subject instanceof InternalReactiveThrownException()) {
            var it = _ReactiveState___get_raw__impl__92ipya(this_0).sah_1;
            tmp = new (ReactiveState())(Companion_getInstance_0().uah(it));
          } else {
            if (tmp0_subject instanceof InternalReactiveWrapper()) {
              var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0).rah_1;
              var it_0 = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
              var tmp_1;
              var tmp_2;
              if (this.hel_1.dem(it_0)) {
                tmp_2 = true;
              } else {
                // Inline function 'com.lightningkite.now' call
                var tmp$ret$2 = get_default(Companion_instance).d1m();
                tmp_2 = Duration__compareTo_impl_pchp0f(tmp$ret$2.x26(it_0.cem_1), this.yek_1) < 0;
              }
              if (tmp_2) {
                tmp_1 = _ReactiveState___init__impl__fvdp9b(it_0.bem_1);
              } else {
                tmp_1 = Companion_getInstance_0().mah_1;
              }
              tmp = new (ReactiveState())(tmp_1);
            } else {
              var it_1 = _ReactiveState___get_raw__impl__92ipya(this_0);
              var tmp_3;
              var tmp_4;
              if (this.hel_1.dem(it_1)) {
                tmp_4 = true;
              } else {
                // Inline function 'com.lightningkite.now' call
                var tmp$ret$4 = get_default(Companion_instance).d1m();
                tmp_4 = Duration__compareTo_impl_pchp0f(tmp$ret$4.x26(it_1.cem_1), this.yek_1) < 0;
              }
              if (tmp_4) {
                tmp_3 = _ReactiveState___init__impl__fvdp9b(it_1.bem_1);
              } else {
                tmp_3 = Companion_getInstance_0().mah_1;
              }
              tmp = new (ReactiveState())(tmp_3);
            }
          }
        }
        return tmp.gao_1;
      }
      qah() {
        return this.var();
      }
      tah(listener) {
        return this.eel_1.tah(listener);
      }
      len(modification, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_modify__nczk7i.bind(VOID, this, modification), $completion);
      }
      iem($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt.bind(VOID, this), $completion);
      }
      men(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_set__cb7isu.bind(VOID, this, value), $completion);
      }
      gah(value, $completion) {
        return this.men((value == null ? true : isInterface(value, HasId())) ? value : THROW_CCE(), $completion);
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        if (other instanceof ModelCacheItemReadableImpl()) {
          tmp_1 = equals(this.xek_1, other.xek_1);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.yek_1 === other.yek_1;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.zek_1 === other.zek_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return (hashCode(this.xek_1) + Duration__hashCode_impl_u4exz6(this.yek_1) | 0) + Duration__hashCode_impl_u4exz6(this.zek_1) | 0;
      }
    }
    protoOf($).tak = lens_0;
    protoOf($).bak = lens_1;
    protoOf($).iaj = beginUse;
    initMetadataForClass($, 'ModelCacheItemReadableImpl', VOID, VOID, [Reactive(), MutableReactive()], [0, 1]);
    ModelCacheItemReadableImplClass = $;
  }
  return ModelCacheItemReadableImplClass;
}
var ModelCacheLimitReadableImplClass;
function ModelCacheLimitReadableImpl() {
  if (ModelCacheLimitReadableImplClass === VOID) {
    class $ {
      constructor($outer, query, maximumAge, pullFrequency) {
        this.xem_1 = $outer;
        this.mem_1 = query;
        this.nem_1 = maximumAge;
        this.oem_1 = pullFrequency;
        this.pem_1 = this.xem_1.ydv_1.tat();
        this.qem_1 = this.mem_1;
        var tmp = this;
        tmp.rem_1 = ResourceUse(this.xem_1.udv_1, ModelCache$ModelCacheLimitReadableImpl$processWhileRunning$slambda_0(this.xem_1, this));
        var tmp_0 = this;
        var tmp_1 = this.xem_1.ddw_1.tek(this.mem_1);
        tmp_0.sem_1 = uses(lensListenable(tmp_1, () => {
          var tmp0_safe_receiver = this.xem_1.ddw_1.vek(this.qem_1);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp_0;
            var tmp_1;
            if (this.xem_1.fen(this.qem_1.s49_1, tmp0_safe_receiver.een_1)) {
              tmp_1 = true;
            } else {
              // Inline function 'com.lightningkite.now' call
              var tmp$ret$0 = get_default(Companion_instance).d1m();
              tmp_1 = Duration__compareTo_impl_pchp0f(tmp$ret$0.x26(tmp0_safe_receiver.een_1), this.nem_1) < 0;
            }
            if (tmp_1) {
              tmp_0 = tmp0_safe_receiver.cen_1;
            } else {
              tmp_0 = null;
            }
            tmp = tmp_0;
          }
          return tmp;
        }), this.rem_1);
        var tmp_2 = this;
        var tmp_3 = this.xem_1.ddw_1.tek(this.mem_1);
        tmp_2.tem_1 = uses(lensListenable(tmp_3, () => {
          var tmp0_safe_receiver = this.xem_1.ddw_1.vek(this.qem_1);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp_0;
            var tmp_1;
            if (this.xem_1.fen(this.qem_1.s49_1, tmp0_safe_receiver.een_1)) {
              tmp_1 = true;
            } else {
              // Inline function 'com.lightningkite.now' call
              var tmp$ret$3 = get_default(Companion_instance).d1m();
              tmp_1 = Duration__compareTo_impl_pchp0f(tmp$ret$3.x26(tmp0_safe_receiver.een_1), this.nem_1) < 0;
            }
            if (tmp_1) {
              tmp_0 = tmp0_safe_receiver;
            } else {
              tmp_0 = null;
            }
            tmp = tmp_0;
          }
          return tmp;
        }), this.rem_1);
        var tmp_4 = this;
        tmp_4.uem_1 = lens(this.tem_1, ModelCache$ModelCacheLimitReadableImpl$lastUpdatedAt$lambda);
        var tmp_5 = this;
        var tmp_6 = this.xem_1.udv_1.ea2();
        tmp_5.vem_1 = remember(tmp_6, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = this.xem_1.zdv_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zel_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            $this$remember.aaj(tmp1_safe_receiver);
          }
          var tmp2_safe_receiver = this.xem_1.ddw_1.vek(this.qem_1);
          var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.een_1;
          var tmp;
          if (tmp3_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp = this.xem_1.fen(this.qem_1.s49_1, tmp3_safe_receiver);
          }
          return tmp === true;
        });
        this.wem_1 = this.mem_1.v49_1;
      }
      nen() {
        var tmp0_safe_receiver = this.xem_1.ddw_1.vek(this.qem_1);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_0;
          var tmp_1;
          if (this.xem_1.fen(this.qem_1.s49_1, tmp0_safe_receiver.een_1)) {
            tmp_1 = true;
          } else {
            // Inline function 'com.lightningkite.now' call
            var tmp$ret$0 = get_default(Companion_instance).d1m();
            tmp_1 = Duration__compareTo_impl_pchp0f(tmp$ret$0.x26(tmp0_safe_receiver.een_1), this.nem_1) < 0;
          }
          if (tmp_1) {
            tmp_0 = _ReactiveState___init__impl__fvdp9b(tmp0_safe_receiver.cen_1);
          } else {
            tmp_0 = Companion_getInstance_0().mah_1;
          }
          tmp = tmp_0;
        }
        var tmp1_elvis_lhs = tmp;
        var tmp_2;
        var tmp_3 = tmp1_elvis_lhs;
        if ((tmp_3 == null ? null : new (ReactiveState())(tmp_3)) == null) {
          tmp_2 = Companion_getInstance_0().mah_1;
        } else {
          tmp_2 = tmp1_elvis_lhs;
        }
        return tmp_2;
      }
      qah() {
        return this.nen();
      }
      tah(listener) {
        return this.sem_1.tah(listener);
      }
      oe1(value) {
        this.wem_1 = value;
        this.qem_1 = this.qem_1.y49(VOID, VOID, VOID, value);
        this.pem_1.oen();
      }
      pe1() {
        return this.wem_1;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        if (other instanceof ModelCacheLimitReadableImpl()) {
          tmp_1 = this.mem_1.equals(other.mem_1);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.nem_1 === other.nem_1;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.oem_1 === other.oem_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return (this.mem_1.hashCode() + Duration__hashCode_impl_u4exz6(this.nem_1) | 0) + Duration__hashCode_impl_u4exz6(this.oem_1) | 0;
      }
    }
    protoOf($).iaj = beginUse;
    initMetadataForClass($, 'ModelCacheLimitReadableImpl', VOID, VOID, [LimitReadable(), Reactive()]);
    ModelCacheLimitReadableImplClass = $;
  }
  return ModelCacheLimitReadableImplClass;
}
function *_generator_add__cbj1ot($this, item, $completion) {
  var tmp = $this.rdv_1.cek(item, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.also' call
  var this_0 = tmp;
  $this.xdv_1.mam(new (MutationResult())(setOf(this_0)));
  return this_0;
}
function *_generator_addAll__fxr06w($this, items, $completion) {
  var tmp = $this.rdv_1.bek(items, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.also' call
  var this_0 = tmp;
  $this.xdv_1.mam(new (MutationResult())(toSet(this_0)));
  return this_0;
}
function *_generator_bulkModify__e51o4k($this, bulkUpdate, $completion) {
  var tmp = $this.rdv_1.dek(bulkUpdate, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.also' call
  var this_0 = tmp;
  $this.xdv_1.mam(new (SocketOverload())());
  return this_0;
}
var ModelCache$multiget$slambdaClass;
function ModelCache$multiget$slambda() {
  if (ModelCache$multiget$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.gen_1 = this$0;
      }
      pen(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.pen((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ModelCache$multiget$slambdaClass = $;
  }
  return ModelCache$multiget$slambdaClass;
}
function ModelCache$multiget$slambda_0(this$0) {
  var i = new (ModelCache$multiget$slambda())(this$0);
  var l = (it, $completion) => i.pen(it, $completion);
  l.$arity = 1;
  return l;
}
var ModelCache$queryInternal$slambdaClass;
function ModelCache$queryInternal$slambda() {
  if (ModelCache$queryInternal$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.qen_1 = this$0;
      }
      ren(it, $completion) {
        return coroutineScope(ModelCache$queryInternal$slambda$slambda_0(it, this.qen_1), $completion);
      }
      s2(p1, $completion) {
        return this.ren((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ModelCache$queryInternal$slambdaClass = $;
  }
  return ModelCache$queryInternal$slambdaClass;
}
function ModelCache$queryInternal$slambda_0(this$0) {
  var i = new (ModelCache$queryInternal$slambda())(this$0);
  var l = (it, $completion) => i.ren(it, $completion);
  l.$arity = 1;
  return l;
}
function ModelCache$localSignalUpdate$lambda(it) {
  var tmp0_safe_receiver = ReactiveState__getOrNull_impl_1asnfp(it.qah());
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bem_1;
}
var ModelCacheClass;
function ModelCache() {
  if (ModelCacheClass === VOID) {
    class $ {
      constructor(skipCache, serializer, onUpdate, scope, log) {
        onUpdate = onUpdate === VOID ? null : onUpdate;
        scope = scope === VOID ? get_AppScope() : scope;
        log = log === VOID ? null : log;
        this.rdv_1 = skipCache;
        this.sdv_1 = serializer;
        this.tdv_1 = onUpdate;
        this.udv_1 = scope;
        this.vdv_1 = log;
        this.wdv_1 = _id(this.sdv_1);
        this.xdv_1 = Signal().fak(new (SocketOverload())());
        this.ydv_1 = new (InterruptibleDelay())();
        var tmp = this;
        var tmp_0 = this.rdv_1;
        var tmp0_safe_receiver = isInterface(tmp_0, ClientModelRestEndpointsPlusUpdatesWebsocket()) ? tmp_0 : null;
        var tmp_1;
        if (tmp0_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp1_scope = this.udv_1;
          var tmp2_socket = tmp0_safe_receiver.rek();
          var tmp0_safe_receiver_0 = this.vdv_1;
          var tmp3_log = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.zbm('Sockets');
          tmp_1 = new (SharedCollectionUpdatesSocket())(tmp1_scope, tmp2_socket, (it) => {
            var tmp;
            if (it.y3o_1) {
              this.xdv_1.mam(new (SocketOverload())());
              tmp = Unit_instance;
            } else {
              this.xdv_1.mam(new (SocketChanges())(it.w3o_1, it.x3o_1, ensureNotNull(this.zdv_1).zel_1.f2().sen_1, this.zdv_1.zel_1.f2().ten_1));
              tmp = Unit_instance;
            }
            return Unit_instance;
          }, tmp3_log);
        }
        tmp.zdv_1 = tmp_1;
        var tmp_2 = this;
        var tmp0_safe_receiver_1 = this.vdv_1;
        var tmp_3 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.zbm('multiget');
        tmp_2.adw_1 = new (BatchAndQueue())(this.udv_1, VOID, tmp_3, ModelCache$multiget$slambda_0(this));
        var tmp_4 = this;
        var tmp0_safe_receiver_2 = this.vdv_1;
        var tmp_5 = tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.zbm('queryInternal');
        tmp_4.bdw_1 = new (BatchAndQueue())(this.udv_1, VOID, tmp_5, ModelCache$queryInternal$slambda_0(this));
        this.cdw_1 = HashMap().n8();
        this.xdv_1.tah(() => {
          var update = this.xdv_1.f2();
          if (update instanceof DeletionResult()) {
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s = update.yej_1.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              // Inline function 'kotlin.collections.getOrPut' call
              var this_0 = this.cdw_1;
              var value = this_0.p3(element);
              var tmp;
              if (value == null) {
                var answer = LateInitSignal().raq();
                this_0.s3(element, answer);
                tmp = answer;
              } else {
                tmp = value;
              }
              var tmp$ret$3 = tmp;
              set_value(tmp$ret$3, new (WithTimestamp())(null));
            }
          } else {
            if (update instanceof MultiGetResult()) {
              // Inline function 'kotlin.collections.forEach' call
              var _iterator__ex2g4s_0 = update.oej().m1();
              while (_iterator__ex2g4s_0.n1()) {
                var element_0 = _iterator__ex2g4s_0.o1();
                var tmp0 = this.cdw_1;
                // Inline function 'kotlin.collections.getOrPut' call
                var key = element_0.h40();
                var value_0 = tmp0.p3(key);
                var tmp_0;
                if (value_0 == null) {
                  var answer_0 = LateInitSignal().raq();
                  tmp0.s3(key, answer_0);
                  tmp_0 = answer_0;
                } else {
                  tmp_0 = value_0;
                }
                var tmp$ret$7 = tmp_0;
                set_value(tmp$ret$7, new (WithTimestamp())(element_0));
              }
              // Inline function 'kotlin.collections.forEach' call
              var _iterator__ex2g4s_1 = update.vej_1.m1();
              while (_iterator__ex2g4s_1.n1()) {
                var element_1 = _iterator__ex2g4s_1.o1();
                // Inline function 'kotlin.collections.getOrPut' call
                var this_1 = this.cdw_1;
                var value_1 = this_1.p3(element_1);
                var tmp_1;
                if (value_1 == null) {
                  var answer_1 = LateInitSignal().raq();
                  this_1.s3(element_1, answer_1);
                  tmp_1 = answer_1;
                } else {
                  tmp_1 = value_1;
                }
                var tmp$ret$11 = tmp_1;
                set_value(tmp$ret$11, new (WithTimestamp())(null));
              }
            } else {
              if (update instanceof SocketChanges()) {
                // Inline function 'kotlin.collections.forEach' call
                var _iterator__ex2g4s_2 = update.pej_1.m1();
                while (_iterator__ex2g4s_2.n1()) {
                  var element_2 = _iterator__ex2g4s_2.o1();
                  var tmp0_0 = this.cdw_1;
                  // Inline function 'kotlin.collections.getOrPut' call
                  var key_0 = element_2.h40();
                  var value_2 = tmp0_0.p3(key_0);
                  var tmp_2;
                  if (value_2 == null) {
                    var answer_2 = LateInitSignal().raq();
                    tmp0_0.s3(key_0, answer_2);
                    tmp_2 = answer_2;
                  } else {
                    tmp_2 = value_2;
                  }
                  var tmp$ret$15 = tmp_2;
                  set_value(tmp$ret$15, new (WithTimestamp())(element_2));
                }
                // Inline function 'kotlin.collections.forEach' call
                var _iterator__ex2g4s_3 = update.qej_1.m1();
                while (_iterator__ex2g4s_3.n1()) {
                  var element_3 = _iterator__ex2g4s_3.o1();
                  // Inline function 'kotlin.collections.getOrPut' call
                  var this_2 = this.cdw_1;
                  var value_3 = this_2.p3(element_3);
                  var tmp_3;
                  if (value_3 == null) {
                    var answer_3 = LateInitSignal().raq();
                    this_2.s3(element_3, answer_3);
                    tmp_3 = answer_3;
                  } else {
                    tmp_3 = value_3;
                  }
                  var tmp$ret$19 = tmp_3;
                  set_value(tmp$ret$19, new (WithTimestamp())(null));
                }
              } else {
                if (update instanceof SocketOverload()) {
                  // Inline function 'kotlin.collections.forEach' call
                  var _iterator__ex2g4s_4 = this.cdw_1.r3().m1();
                  while (_iterator__ex2g4s_4.n1()) {
                    var element_4 = _iterator__ex2g4s_4.o1();
                    element_4.saq();
                  }
                } else {
                  var tmp0_safe_receiver = update.oej();
                  if (tmp0_safe_receiver == null)
                    null;
                  else {
                    // Inline function 'kotlin.collections.forEach' call
                    var _iterator__ex2g4s_5 = tmp0_safe_receiver.m1();
                    while (_iterator__ex2g4s_5.n1()) {
                      var element_5 = _iterator__ex2g4s_5.o1();
                      var tmp0_1 = this.cdw_1;
                      // Inline function 'kotlin.collections.getOrPut' call
                      var key_1 = element_5.h40();
                      var value_4 = tmp0_1.p3(key_1);
                      var tmp_4;
                      if (value_4 == null) {
                        var answer_4 = LateInitSignal().raq();
                        tmp0_1.s3(key_1, answer_4);
                        tmp_4 = answer_4;
                      } else {
                        tmp_4 = value_4;
                      }
                      var tmp$ret$25 = tmp_4;
                      set_value(tmp$ret$25, new (WithTimestamp())(element_5));
                    }
                  }
                }
              }
            }
          }
          return Unit_instance;
        });
        var tmp_6 = this;
        var tmp0_safe_receiver_3 = this.vdv_1;
        tmp_6.ddw_1 = new (NaiveListReconstructionCalculator())(this.sdv_1, tmp0_safe_receiver_3 == null ? null : tmp0_safe_receiver_3.zbm('CollectionCache'));
        this.xdv_1.tah(() => {
          this.ddw_1.uek(this.xdv_1.f2());
          return Unit_instance;
        });
        var tmp_7 = this;
        var tmp0_onBufferOverflow = BufferOverflow_DROP_OLDEST_getInstance();
        tmp_7.edw_1 = MutableSharedFlow(VOID, 1, tmp0_onBufferOverflow);
      }
      dem(_this__u8e3s4) {
        var tmp;
        if (!(_this__u8e3s4.bem_1 == null)) {
          var tmp0_safe_receiver = this.zdv_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zel_1;
          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f2();
          var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.ten_1;
          var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : asSequence(tmp3_safe_receiver);
          var tmp_0;
          if (tmp4_safe_receiver == null) {
            tmp_0 = null;
          } else {
            tmp_0 = filter(tmp4_safe_receiver, (it) => it.nel_1.t3q(_this__u8e3s4.bem_1));
          }
          var tmp5_safe_receiver = tmp_0;
          var tmp_1;
          if (tmp5_safe_receiver == null) {
            tmp_1 = null;
          } else {
            var tmp$ret$0;
            $l$block: {
              // Inline function 'kotlin.sequences.minOfOrNull' call
              var iterator = tmp5_safe_receiver.m1();
              if (!iterator.n1()) {
                tmp$ret$0 = null;
                break $l$block;
              }
              var tmp0_elvis_lhs = iterator.o1().oel_1;
              var minValue = tmp0_elvis_lhs == null ? Companion_getInstance_1().f1m_1 : tmp0_elvis_lhs;
              while (iterator.n1()) {
                var tmp0_elvis_lhs_0 = iterator.o1().oel_1;
                var v = tmp0_elvis_lhs_0 == null ? Companion_getInstance_1().f1m_1 : tmp0_elvis_lhs_0;
                if (compareTo(minValue, v) > 0) {
                  minValue = v;
                }
              }
              tmp$ret$0 = minValue;
            }
            tmp_1 = tmp$ret$0;
          }
          var tmp6_safe_receiver = tmp_1;
          var tmp_2;
          if (tmp6_safe_receiver == null) {
            tmp_2 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_2 = _this__u8e3s4.cem_1.y26(tmp6_safe_receiver) > 0;
          }
          tmp = tmp_2 === true;
        } else {
          tmp = false;
        }
        return tmp;
      }
      fen(_this__u8e3s4, timestamp) {
        var tmp0_safe_receiver = this.zdv_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zel_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f2();
        var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.ten_1;
        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : asSequence(tmp3_safe_receiver);
        var tmp;
        if (tmp4_safe_receiver == null) {
          tmp = null;
        } else {
          tmp = filter(tmp4_safe_receiver, (it) => it.nel_1.equals(_this__u8e3s4));
        }
        var tmp5_safe_receiver = tmp;
        var tmp_0;
        if (tmp5_safe_receiver == null) {
          tmp_0 = null;
        } else {
          var tmp$ret$0;
          $l$block: {
            // Inline function 'kotlin.sequences.minOfOrNull' call
            var iterator = tmp5_safe_receiver.m1();
            if (!iterator.n1()) {
              tmp$ret$0 = null;
              break $l$block;
            }
            var tmp0_elvis_lhs = iterator.o1().oel_1;
            var minValue = tmp0_elvis_lhs == null ? Companion_getInstance_1().f1m_1 : tmp0_elvis_lhs;
            while (iterator.n1()) {
              var tmp0_elvis_lhs_0 = iterator.o1().oel_1;
              var v = tmp0_elvis_lhs_0 == null ? Companion_getInstance_1().f1m_1 : tmp0_elvis_lhs_0;
              if (compareTo(minValue, v) > 0) {
                minValue = v;
              }
            }
            tmp$ret$0 = minValue;
          }
          tmp_0 = tmp$ret$0;
        }
        var tmp6_safe_receiver = tmp_0;
        var tmp_1;
        if (tmp6_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_1 = timestamp.y26(tmp6_safe_receiver) > 0;
        }
        return tmp_1 === true;
      }
      eem(_this__u8e3s4, recencyRequirement) {
        var tmp;
        if (this.dem(_this__u8e3s4)) {
          tmp = recencyRequirement;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance).d1m();
          tmp = Duration__minus_impl_q5cfm7(recencyRequirement, tmp$ret$0.x26(_this__u8e3s4.cem_1));
        }
        return tmp;
      }
      ven(id, maximumAge, pullFrequency) {
        return new (ModelCacheItemReadableImpl())(this, id, maximumAge, pullFrequency);
      }
      xen(query, maximumAge, pullFrequency) {
        return new (ModelCacheLimitReadableImpl())(this, query, maximumAge, pullFrequency);
      }
      zen(item, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_add__cbj1ot.bind(VOID, this, item), $completion);
      }
      aeo(items, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_addAll__fxr06w.bind(VOID, this, items), $completion);
      }
      dek(bulkUpdate, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_bulkModify__e51o4k.bind(VOID, this, bulkUpdate), $completion);
      }
      beo($completion) {
        this.edw_1.sae(Unit_instance);
        this.xdv_1.mam(new (SocketOverload())());
        this.ydv_1.oen();
      }
      ceo(matching, modify) {
        var updates = HashSet().ha();
        var removals = HashSet().ha();
        var tmp = asSequence(this.cdw_1.r3());
        // Inline function 'kotlin.sequences.forEach' call
        var _iterator__ex2g4s = filter(mapNotNull(tmp, ModelCache$localSignalUpdate$lambda), matching).m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp0_safe_receiver = modify(element);
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = updates.v(tmp0_safe_receiver);
          }
          if (tmp_0 == null)
            removals.v(element.h40());
        }
        this.xdv_1.mam(new (MutationResult())(updates));
        this.xdv_1.mam(new (DeletionResult())(removals));
      }
      deo(item) {
        this.xdv_1.mam(new (MutationResult())(setOf(item)));
        return item;
      }
    }
    protoOf($).wen = item$default;
    protoOf($).yen = list$default;
    protoOf($).eeo = get;
    protoOf($).feo = query;
    protoOf($).geo = watch;
    protoOf($).kdw = watch_0;
    protoOf($).cek = insert;
    initMetadataForClass($, 'ModelCache', VOID, VOID, [ModelCacheLike()], [1, 0]);
    ModelCacheClass = $;
  }
  return ModelCacheClass;
}
//region block: exports
export {
  ModelCache as ModelCache1j2q0r8bmhrox,
};
//endregion

//# sourceMappingURL=ModelCache.mjs.map
